import styled from 'styled-components';

export const HistoricContainer = styled.div`
  .ant-card {
    margin-bottom: 16px;

    table {
      border: 1px solid ${({ theme }) => theme.colors.border} !important;
      margin-bottom: 8px;
    }

    .ant-switch {
      pointer-events: none;
    }

    .historic-card-emails {
      color: ${({ theme }) => theme.colors.text};
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .ant-list-item {
    border: none;
  }
`;
